import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchCompliance(action) {
  try {    
    const { filtersString, category, view } = action.payload || {};
    const response = yield call(API.fetchCommodityWiseCompliance, {
      filtersString,
      category,
      view
    });
    const payload = response.data?.data || response.data;
    yield put(actions.fetchComplianceSuccess(payload));
    
  } catch (error) {
    console.error("❌ Commodity Compliance saga error:", error);
    yield put(actions.fetchComplianceFailure(error.message || "Unknown error"));
  }
}

export function* commodityComplianceSaga() {
  yield takeLatest(actions.fetchCompliance.type, handleFetchCompliance);
}